import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
} 

export const slugify = (s: string) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const deckImg = (assetDir: string, name: string) => `/imgs/${assetDir}/${slugify(name)}.webp`;